import styled from '@emotion/styled';

import { CONTAINER } from 'styles';

export const Footer = styled.footer`
  ${CONTAINER}
  margin: 1em auto;
`;
